export default "__VITE_ASSET__CpyL35Rf__"